// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__ySwWs","cardBox":"Card_cardBox__PJpN6","backToHome":"Card_backToHome__LTR_F"};